<mat-list-item (click)="onClick()" class="toggle-button-container">
  <!-- Content for expanded sidebar -->
  <div *ngIf="isExpanded()" class="flex justify-end w-full">
    <mat-icon class="toggle-icon" mat-list-icon> menu </mat-icon>
  </div>

  <!-- Content for collapsed sidebar -->
  <div *ngIf="!isExpanded()" class="flex justify-center w-full">
    <mat-icon class="toggle-icon" mat-list-icon> menu </mat-icon>
  </div>
</mat-list-item>
